/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface NotificacionesControllerMarcarNotificacionLeida$Params {

/**
 * UUID de la notificación a marcar como leída
 */
  uuidNotificacion: string;
}

export function notificacionesControllerMarcarNotificacionLeida(http: HttpClient, rootUrl: string, params: NotificacionesControllerMarcarNotificacionLeida$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, notificacionesControllerMarcarNotificacionLeida.PATH, 'put');
  if (params) {
    rb.path('uuidNotificacion', params.uuidNotificacion, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

notificacionesControllerMarcarNotificacionLeida.PATH = '/api/notificaciones/marcar-notificacion-leida/{uuidNotificacion}';
